// NPM Imports
import React from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { Button } from "../../../../commonComponents";

// Internal Imports
import { Loader, Toastr, Button } from "@revvsales/components";
import { SETTINGS } from "../../../../constants";
import { ConfirmationBoxV2 } from "../../../../commonComponents";

import {
  getAuthStripe,
  deactivateStripeUser,
  stripeUserDetails,
} from "../../../../actions/DocumentActions";

import {
  readDataFromLocalStorage,
  writeDataToLocalStorage,
  removeDataFromLocalStorage,
} from "../../../../utils/globalUtils";

// destructuring
const { CRM_LOGOS_MAPPING, CRM_NAMES_MAPPING } = SETTINGS;

class StripeSettings extends React.Component {
  state = {
    disableStripe: false,
  };

  componentDidMount = async () => {
    const { stripePaymentDetails, stripeFlag } = this.props;
    const query = new URLSearchParams(window.location.search);

    const payload = {
      grant_type: "authorization_code",
      code: query.get("code"),
    };

    const stripeData = readDataFromLocalStorage("stripeData");

    const { origin, pathname } = window.location;
    if (!stripeData) {
      if (query.get("success") === "true") {
        if (query.get("error") !== "access_denied") {
          await this.props
            .getAuthStripe(payload)
            .then(res => res)
            .catch(() => {
              Toastr.showToastr({
                type: "warning",
                message: `Oops! Someone in your org alredy uses this stripeID`,
                timeout: 3000,
              });
            });
        }
        window.location.replace(origin + pathname);
      } else if (stripeFlag && !stripePaymentDetails) {
        await this.props.stripeUserDetails();
      }
    } else if (!stripeData.is_active && payload.code) {
      await this.props.getAuthStripe(payload);
      window.location.replace(origin + pathname);
    }
    const redirectDocNumber = readDataFromLocalStorage("docNo");
    const redirectTempNumber = readDataFromLocalStorage("templateID");
    if (redirectDocNumber) {
      removeDataFromLocalStorage("docNo");
      window.location.replace(`${origin}/documents/${redirectDocNumber}`);
    }
    if (redirectTempNumber) {
      removeDataFromLocalStorage("templateID");
      window.location.replace(`${origin}/template/${redirectTempNumber}`);
    }
  };

  _connectToStripe = () => {
    const { docNo } = this.props.match.params;
    const { templateID } = this.props.match.params;
    if (docNo) writeDataToLocalStorage("docNo", this.props.document.docNo);
    if (templateID) writeDataToLocalStorage("templateID", templateID);
    window.location.replace(
      `${
        process.env.REACT_APP_STRIPE_SUBSCRIBER
      }?response_type=code&client_id=${
        process.env.REACT_APP_STRIPE_CLINT_ID
      }&scope=read_write&redirect_uri=${
        process.env.REACT_APP_STRIPE_REDIRECT
      }/settings/integrations/stripe/?success=true&stripe_landing=login`,
    );
  };

  createButton = () => {
    const { stripePaymentDetails } = this.props;
    let component = null;
    component = (
      <div>
        <button
          data-test="stripe-settings-connect-btn"
          onClick={this._connectToStripe}
          type="button"
          className={`stripe-button activate ${
            stripePaymentDetails && stripePaymentDetails.is_active
              ? "connection-disabled"
              : ""
          }`}>
          {/* <span className="s-logo">S</span> */}
          <span className="connect-stripe">Connect with Stripe</span>
        </button>
      </div>
    );

    return component;
  };

  _toggleCustomLoader = (type, flag) => {
    this.setState({ [type]: flag });
  };

  _closeDeleteItemsPopup = () => {
    this.setState({ disableStripe: false });
  };

  _disconnectStripeUser = () => {
    const { stripePaymentDetails } = this.props;
    this.props.deactivateStripeUser(stripePaymentDetails.stripe_user_id);
    // this._closeDeleteItemsPopup();
  };

  deactivateButton = () => {
    let component = null;
    component = (
      <div>
        <Button
          data-test="stripe-settings-disconnect-btn"
          onClick={() => this._toggleCustomLoader("disableStripe", true)}
          type="button"
          className="revv-btn-secondary ">
          Disconnect my account
        </Button>
      </div>
    );

    return component;
  };

  render() {
    const { stripePaymentDetails } = this.props;
    let popupSpace = null;
    const redirectDocNumber = readDataFromLocalStorage("docNo");
    const redirectTempNumber = readDataFromLocalStorage("templateID");
    const query = new URLSearchParams(window.location.search);
    if (
      query.get("success") === "true" &&
      (query.get("error") !== "access_denied" ||
        redirectDocNumber ||
        redirectTempNumber)
    ) {
      return <Loader label="Redirecting...." largeLabel isFull />;
    }

    if (this.state.disableStripe && stripePaymentDetails) {
      popupSpace = (
        <ConfirmationBoxV2
          header="⚠️ You're about to disconnect your Stripe account"
          subHeader="If you disconnect your account, you can no longer add payment buttons to collect payments from your recipients. You can connect again anytime."
          closePopup={this._closeDeleteItemsPopup}
          checkboxLabel="Yes, I want to disconnect"
          confirmAction={() => this._disconnectStripeUser()}
          okBtnText="Disconnect Stripe from Revv"
          cancelBtnText="Cancel"
        />
      );
    }

    return (
      <div>
        {popupSpace}
        {!this.props.pane ? (
          <div className="col-md-10 offset-md-1">
            {/* -------- Integration Header Section ------------- */}
            <div className="row teammate-header">
              <div className="col-md-9 role-name-space">
                <span className="back-angle-button">
                  <Link to="/settings/integrations/">
                    <div className="roledetails-back-ico">
                      <FontAwesomeIcon icon={["far", "angle-left"]} />
                    </div>
                  </Link>
                </span>
                <span className="role-title">
                  {CRM_NAMES_MAPPING[this.props.crmParam]} : Integration
                  Settings
                </span>
              </div>
              <div className="col-md-3 save-discard-together">
                <img
                  className="integration-logo-header"
                  src={CRM_LOGOS_MAPPING[this.props.crmParam]}
                  alt="CRM Logo"
                />
              </div>
            </div>
            <hr />
            <div>
              <div className="row">
                <div className="col-md-12 sync-bar">
                  <div className="stripesettings-info-container">
                    <div className="info-icon">
                      <FontAwesomeIcon icon={["far", "info-circle"]} />
                    </div>
                    <div className="stripesettings-info-wrapper">
                      <div className="stripesettings-info-title">
                        Enable one-click payments via Stripe for your recipients
                        when you share documents with them. Securely integrate
                        Revv with your Stripe account for free in 3 easy steps
                      </div>
                      {/* <div className="stripesettings-info-title">
                        You will need a Stripe accont before you integrate.
                        Learn more about it here:
                        <a
                          className="stripesettings-info-link"
                          href="https://stripe.com/docs/payments/accept-a-payment?integration=checkout"
                          target="_blank"
                          rel="noopener noreferrer">
                          How to add Stripe to your Revv account?
                        </a>
                      </div> */}
                      <div className="stripesettings-info-container">
                        <div className="stripesettings-actrig-section">
                          <div className="stripesettings-actrig-text-wrapper">
                            <span className="margin-bottom">
                              1: Click Connect with Stripe below
                            </span>
                            <span className="margin-bottom">
                              2: On the Stripe page sign into your Stripe
                              account
                            </span>
                            <span>
                              3: Authenticate your account to connect with Revv
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="stripesettings-info-title">
                        All payments will be managed in and by Stripe. You will
                        not incur any charges from Revv.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr />
              {stripePaymentDetails && stripePaymentDetails.is_active ? (
                <div>
                  <div className="activate-deactivate">
                    <div>
                      <FontAwesomeIcon
                        icon={["fas", "check-circle"]}
                        color="green"
                      />
                    </div>
                    <div className="">Connected to your Stripe account</div>
                  </div>
                  <div className="activate-deactivate">
                    {this.createButton()}
                    {this.deactivateButton()}
                  </div>
                </div>
              ) : (
                this.createButton()
              )}
            </div>
          </div>
        ) : (
          <div>{this.createButton()}</div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {
    stripePaymentDetails,
    component,
    document,
    stripeFlag,
  } = state.DocumentStore;

  return {
    stripePaymentDetails,
    component,
    document,
    stripeFlag,
  };
};

const mapDispatchToProps = {
  getAuthStripe,
  deactivateStripeUser,
  stripeUserDetails,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(StripeSettings));



// WEBPACK FOOTER //
// ./src/components/SettingsWrapper/IntegrationsSettings/StripeSettings/StripeSettings.js